import * as go from 'gojs';
import {
  ANGLE_PROP,
  BACKGROUND_COLOR_PROP,
  BORDER_COLOR_PROP,
  BORDER_STYLE_PROP,
  BORDER_WIDTH_PROP,
  EXPANDED_PROP,
  GEOMETRY_STRING_PROP,
  GROUP_DESCRIPTION_PROP,
  GROUP_TITLE_PROP,
  LAYER_NAME_PROP,
  LOCATION_PROP,
  LOCKED_PROP,
  SHADOW_BLUR_PROP,
  SHADOW_COLOR_PROP,
  SHADOW_OFFSET_PROP,
  SIZE_PROP,
  TEXT_ALIGNMENT_PROP,
  TEXT_COLOR_PROP,
  TEXT_FONT_PROP,
  TEXT_HIGHLIGHT_COLOR_PROP,
  TEXT_PROP,
  Z_ORDER_PROP,
} from '../config/common-prop-names';

export const locationBinding = () =>
  new go.Binding('location', LOCATION_PROP, go.Point.parse).makeTwoWay(go.Point.stringify);

export const angleBinding = () => new go.Binding('angle', ANGLE_PROP).makeTwoWay();

export const shadowBindings = () => [
  new go.Binding('shadowColor', SHADOW_COLOR_PROP),
  new go.Binding('shadowBlur', SHADOW_BLUR_PROP),
  new go.Binding('shadowOffset', SHADOW_OFFSET_PROP, go.Point.parse),
];

export const sizeBinding = () => new go.Binding('desiredSize', SIZE_PROP, go.Size.parse).makeTwoWay(go.Size.stringify);

export const fillBinding = () => new go.Binding('fill', BACKGROUND_COLOR_PROP);

export const textFontBinding = () => new go.Binding('font', TEXT_FONT_PROP);

export const textBinding = () => new go.Binding('text', TEXT_PROP).makeTwoWay();

export const textColorBinding = () => new go.Binding('stroke', TEXT_COLOR_PROP);

export const zOrderBindings = () => [
  new go.Binding('layerName', LAYER_NAME_PROP),
  new go.Binding('zOrder', Z_ORDER_PROP),
];

export const textAlignmentBinding = () => new go.Binding('textAlign', TEXT_ALIGNMENT_PROP);

export const textHighlightColorBinding = () =>
  new go.Binding('fill', TEXT_HIGHLIGHT_COLOR_PROP, (fill) => fill || null);

export const geometryStringBinding = () => new go.Binding('geometryString', GEOMETRY_STRING_PROP);

export const borderColorBinding = () => new go.Binding('stroke', BORDER_COLOR_PROP);

export const borderWidthBinding = () => new go.Binding('strokeWidth', BORDER_WIDTH_PROP);

export const borderStyleBinding = () =>
  new go.Binding('strokeDashArray', '', (data: go.ObjectData) => {
    const width = data[BORDER_WIDTH_PROP];
    const style = data[BORDER_STYLE_PROP];
    if (!width || !style) {
      return [];
    }

    switch (style) {
      case 'solid':
        return [];
      case 'dashed':
        return [3 * width, width];
      case 'dotted':
        return [width, 3 * width];
      default:
        return [];
    }
  });

export const lineStyleBinding = () =>
  new go.Binding('strokeDashArray', '', (data: go.ObjectData) => {
    const width = data[BORDER_WIDTH_PROP];
    const style = data[BORDER_STYLE_PROP];
    if (!width || !style) {
      return [];
    }

    switch (style) {
      case 'solid':
        return [];
      case 'dashed':
        return [width, 2 * width];
      case 'dotted':
        return [width / 2, 2 * width];
      default:
        return 'solid';
    }
  });

export const fromPortIdBinding = () => new go.Binding('fromPortId').makeTwoWay();

export const toPortIdBinding = () => new go.Binding('toPortId').makeTwoWay();

export const lockedBindings = (props: { movable?: boolean; resizable?: boolean; rotatable?: boolean }) => [
  new go.Binding('movable', LOCKED_PROP, (locked) => !locked && !!props.movable),
  new go.Binding('resizable', LOCKED_PROP, (locked) => !locked && !!props.resizable),
  new go.Binding('rotatable', LOCKED_PROP, (locked) => !locked && !!props.rotatable),
];

export const editableBinding = () => new go.Binding('editable', LOCKED_PROP, (locked) => !locked);

export const subGraphExpandedBinding = () => new go.Binding('isSubGraphExpanded', EXPANDED_PROP).makeTwoWay();

export const nodeGroupTitleBinding = () => new go.Binding('text', GROUP_TITLE_PROP).makeTwoWay();

export const nodeGroupDescriptionBinding = () => new go.Binding('text', GROUP_DESCRIPTION_PROP).makeTwoWay();
